<template>
  <div class="wpb_content specify">
    <div class="specify-content">
      <h2>SPECIFICEER UW AANVRAAG</h2>
      <p>{{ category.title }}</p>
      <p class="category-content" v-html="category.content"></p>
      <form
        action=""
        id="specify-free"
        class="specify-form"
        enctype="multipart/form-data"
      >
        <div class="form-label lg-select no-padding">
          <strong>KIES EEN KWALITEIT</strong>
          <v-select
            class="v-select"
            v-model="activeSteel"
            :options="steels"
            :searchable="false"
          >
          </v-select>
        </div>
        <div class="specify-form-row clearfix">
          <div class="form-label md-select">
            <strong>VORM</strong>
            <v-select
              class="v-select"
              label="name"
              v-model="shape"
              :options="shapeOptions"
              :searchable="false"
            ></v-select>
          </div>
        </div>
        <div class="form-label">
          <strong style="margin-top: 30px">MAAT</strong>
          <div class="specify-form-row clearfix">
            <div class="md-select">
              <input
                type="text"
                v-show="shape == 'Plat'"
                v-model="width"
                class="form-field"
                placeholder="Breedte"
              />
            </div>
            <div class="md-select">
              <input
                type="text"
                v-show="shape == 'Plat'"
                v-model="thickness"
                class="form-field"
                placeholder="Dikte"
              />
            </div>
            <div class="md-select">
              <input
                type="text"
                v-show="shape == 'Rond'"
                v-model="radius"
                class="form-field"
                placeholder="Diameter"
              />
            </div>
            <div class="md-select">
              <input
                type="text"
                v-model="length"
                class="form-field"
                placeholder="Lengte"
              />
            </div>
          </div>
        </div>
        <div class="specify-form-row clearfix" style="margin-top: 30px">
          <div class="form-label md-select">
            <strong>AANTAL</strong>
            <v-select
              class="v-select"
              v-model="amount"
              :options="amountOptions"
              :searchable="false"
            ></v-select>
          </div>
          <!-- uploadAvailable is found in the Mixin -->
          <div class="form-label lg-select file-input" v-if="uploadAvailable">
            <strong>BESTAND UPLOADEN?</strong>
            <label for="file-field">UPLOADEN</label>
            <input
              type="file"
              class="form-field"
              id="file-field"
              name="file"
              @change="setOfferteAvailable()"
            />
            <span class="file-name"></span>
            <span class="clear-file-input"></span>
          </div>
        </div>
      </form>
    </div>
    <aside class="right-sidebar">
      <div class="right-bar-sticky-container">
        <div class="right-bar-inner">
          <div class="right-bar-section heading-area">
            <p class="code">{{ activeSteel.name }}</p>
            <p class="heading">{{ activeSteel.type }}</p>
          </div>
          <div class="right-bar-section">
            <h6>MAAT</h6>
            <p>
              <span>Lengte</span><span v-if="length">{{ length }} mm</span>
            </p>
            <p v-show="shape == 'Plat'">
              <span>Breedte</span><span v-if="width">{{ width }} mm</span>
            </p>
            <p v-show="shape == 'Plat'">
              <span>Dikte</span><span v-if="thickness">{{ thickness }} mm</span>
            </p>
            <p v-show="shape == 'Rond'">
              <span>Diameter</span><span v-if="radius">{{ radius }} mm</span>
            </p>
          </div>
          <div class="right-bar-section" style="padding-bottom: 30px;">
            <h6>VORM & AANTAL</h6>
            <p>
              <span>Vorm</span><span>{{ shape }}</span>
            </p>
            <p>
              <span>Aantal</span><span>{{ amount }} Stuks</span>
            </p>
          </div>
        </div>
        <button
          class="specify-btn-blue"
          v-bind:disabled="!offerteAvailable || posting"
          @click="sendForm()"
        >
          OFFERTE
        </button>
      </div>
    </aside>
  </div>
</template>
<script>
let auth = document.head.querySelector('meta[name="auth"]').content;

import customerFreeFillable from "./helpers/vrij/customer";
import guestFreeFillable from "./helpers/vrij/guest";

import vSelect from "vue-select";

let mixin = guestFreeFillable;

if (parseInt(auth)) {
  mixin = customerFreeFillable;
}

export default {
  mixins: [mixin],
  components: {
    "v-select": vSelect,
  },
  props: ["steels", "orderLine", "steel", "category"],
  data: function () {
    return {
      shapeOptions: ["Plat", "Rond"],
      shape: "Plat",
      activeSteel: this.steel,

      fileUploaded: false,

      length: null,
      width: null,
      thickness: null,
      radius: null,

      amountOptions: [],
      amount: 1,

      posting: false,

      guestOrderLines: [],
    };
  },
};
</script>
<style>
.category-content p{
    color:#808080;
    text-transform:none;
}
.dropdown-menu li.active {
  display: none;
}
.v-select .dropdown-toggle {
  height: 50px;
}

.v-select.open .selected-tag {
  /* margin-top:12px; */
}

.v-select.single.open .selected-tag {
  position: static;
}

.v-select.single .selected-tag {
  font-size: 18px;
  font-weight: 900;
  line-height: 1;
}
.v-select .selected-tag {
  margin: 0 2px 0;
  color: #000 !important;
}

.v-select .dropdown-toggle .vs__actions .clear {
  display: none;
}

.v-select .dropdown-toggle {
  border-radius: 0px;
}

.v-select {
  border: 1px solid #d5d5d5;
}

.v-select .open-indicator {
  width: 20px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/product/specificeren-vrij.vue